import { render, staticRenderFns } from "./ImportObserveTable.vue?vue&type=template&id=050df1b1&"
import script from "./ImportObserveTable.vue?vue&type=script&lang=js&"
export * from "./ImportObserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports